import { createFileRoute } from "@tanstack/react-router";
import { TrendingUp, Rocket, Home, Building2 } from "lucide-react";
import { PlatformHub } from "@/components/marketing/PlatformHub";
import { alternateLinkList } from "@/lib/i18n/locale";
import heroImg from "@/assets/networking.jpg";

export const Route = createFileRoute("/el/solutions/")({
  head: () => ({
    meta: [
      { title: "Λύσεις ανά ομάδα — Πωλήσεις, ιδρυτές, ακίνητα & μεγάλες επιχειρήσεις | Banana" },
      { name: "description", content: "Το Banana προσαρμόζεται στον τρόπο που εργάζεται πραγματικά η ομάδα σας — πωλήσεις, ιδρυτές, ακίνητα και μεγάλες επιχειρήσεις. Επιλέξτε τη δική σας προσέγγιση." },
      { property: "og:title", content: "Λύσεις ανά ομάδα — Πωλήσεις, ιδρυτές, ακίνητα & μεγάλες επιχειρήσεις | Banana" },
      { property: "og:description", content: "Ομάδες πωλήσεων, ιδρυτές, επαγγελματίες ακινήτων, μεγάλες επιχειρήσεις — δείτε πώς το Banana ταιριάζει στον τρόπο που εργάζεστε." },
      { property: "og:image", content: heroImg },
      { property: "og:locale", content: "el_GR" },
    ],
    links: alternateLinkList("/solutions", "el"),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Λύσεις ανά ομάδα — Πωλήσεις, ιδρυτές, ακίνητα & μεγάλες επιχειρήσεις | Banana",
          description: "Το Banana προσαρμόζεται στον τρόπο που εργάζεται πραγματικά η ομάδα σας — πωλήσεις, ιδρυτές, ακίνητα και μεγάλες επιχειρήσεις. Επιλέξτε τη δική σας προσέγγιση.",
          url: "https://banana.cards/el/solutions",
          isPartOf: { "@type": "WebSite", name: "banana.cards", url: "https://banana.cards" },
        }),
      },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <PlatformHub
      eyebrow="Λύσεις"
      title="Σχεδιασμένο για τον τρόπο που"
      italic="εργάζεται πραγματικά η ομάδα σας."
      description="Η ίδια πλατφόρμα Banana, προσαρμοσμένη σε τέσσερις διαφορετικούς τρόπους εργασίας. Επιλέξτε αυτόν που σας ταιριάζει — θα σας δείξουμε τον ιδανικό συνδυασμό καρτών, CRM και εφαρμογών."
      heroImage={heroImg}
      features={[
        {
          title: "Για ομάδες πωλήσεων",
          desc: "Κλείστε περισσότερες συμφωνίες σε λιγότερο χρόνο. Καταγράψτε κάθε υποψήφιο πελάτη σε δευτερόλεπτα, αυτοματοποιήστε το follow-up και διατηρήστε το pipeline σας αξιόπιστο.",
          href: "/el/solutions/sales",
          icon: TrendingUp,
          bullets: ["Άμεση καταγραφή υποψήφιων πελατών", "Προσχέδια follow-up με AI", "Pipeline που ενημερώνεται μόνο του"],
        },
        {
          title: "Για ιδρυτές",
          desc: "Μη χάσετε ποτέ ξανά μια επαφή. Ο δεύτερος εγκέφαλός σας για κάθε καφέ, συνέδριο και νέα γνωριμία.",
          href: "/el/solutions/founders",
          icon: Rocket,
          bullets: ["Μνήμη AI για κάθε επαφή", "Έξυπνες υπενθυμίσεις", "Ένα προφίλ, σε κάθε κανάλι"],
        },
        {
          title: "Για επαγγελματίες ακινήτων",
          desc: "Μείνετε η πρώτη επιλογή κάθε πελάτη. Αγγελίες, ραντεβού και αξιολογήσεις σε μια κάρτα που μοιράζεστε με ένα άγγιγμα.",
          href: "/el/solutions/real-estate",
          icon: Home,
          bullets: ["Κρατήσεις πάνω στην κάρτα σας", "Αυτοματοποίηση αξιολογήσεων", "Αγγελίες & καταγραφή επαφών"],
        },
        {
          title: "Για μεγάλες επιχειρήσεις",
          desc: "SSO, ασφάλεια και χρέωση ανά χρήστη. Διαθέστε κάρτες με την εταιρική σας ταυτότητα σε χιλιάδες εργαζομένους μέσα σε μία ημέρα.",
          href: "/el/solutions/enterprise",
          icon: Building2,
          bullets: ["SAML SSO & SCIM", "Εταιρικά πρότυπα σε μεγάλη κλίμακα", "Αρχεία ελέγχου & DPA"],
        },
      ]}
      outro={{ title: "Δεν ξέρετε ποια λύση σας ταιριάζει;", italic: "Ας μιλήσουμε.", description: "Πείτε μας πώς εργάζεται η ομάδα σας και σε 15 λεπτά θα σας δείξουμε πώς προσαρμόζεται το Banana στις ανάγκες σας." }}
    />
  );
}